import CommentBody from "./CommentBody";

export default CommentBody;
